/* eslint-disable react/no-array-index-key */

import React from 'react'
import PropTypes from 'prop-types'
import Loading from 'components/Loading'
import Documents from 'components/Documents'
import Dialog from 'components/Dialog'
import { hasAccess } from 'utils/hasAccess'
import FeatureGuard from '../../components/FeatureToggle/FeatureGuard'

class TaxStatements extends React.Component {
  static propTypes = {
    backToAdminCentreText: PropTypes.string.isRequired,
    documents: PropTypes.object.isRequired,
  }
  static defaultProps = {
    // getDocuments: null,
  }
  constructor(props) {
    super(props)
    this.state = {
      confirmDeleteDialogOpen: false,
      documentSelected: '',
    }
  }

  getDocuments = () => {
    this.props.getDocuments('error')
  }

  _openConfirmDeleteDialog = (itemId) => {
    this.setState({ confirmDeleteDialogOpen: true })
    this.setState({ documentSelected: itemId })
  }

  _closeConfirmDeleteDialog = () => {
    this.setState({ confirmDeleteDialogOpen: false })
  }

  _saveConfirmDeleteDialog = () => {
    this.setState({
      confirmDeleteDialogOpen: false,
    })
    this.props.handleDeleteDocument(this.state.documentSelected)
  }

  render() {
    const confirmDeleteProps = {
      actions: [
        { label: 'CANCEL', onClick: this._closeConfirmDeleteDialog },
        { label: 'DELETE', onClick: this._saveConfirmDeleteDialog },
      ],
      title: 'Are you sure you want to delete this document?',
      active: this.state.confirmDeleteDialogOpen,
      onClose: this._closeConfirmDeleteDialog,
    }
    const { documents, backToAdminCentreText, currentUser } = this.props
    const hasDeleteAccess = hasAccess(this.props.currentUser, 'Tax Statements', this.props.history, 'RW', false)
    if (!documents.isFetching && documents.documents) {
      let allDocuments = documents.documents
      if (documents.documents.length > 0) {
        allDocuments = allDocuments.sort((docA, docB) =>
          docB.Year - docA.Year ||
        docA.Name.localeCompare(docB.Name))
      }
      return (
        <FeatureGuard featureName="Documents" user={currentUser}>
          <div>
            <Documents
              isPdf
              backToAdminCentreText={backToAdminCentreText}
              deleteDocument={this._openConfirmDeleteDialog}
              documentsArray={allDocuments}
              hasDeleteAccess={hasDeleteAccess}
              isAdmin={this.props.currentUser.IsAdmin}
              title="File Name"
            />
            <Dialog {...confirmDeleteProps}>
          You will be not able to bring this back once deleted.
          </Dialog>
          </div>
        </FeatureGuard>
      )
    }
    return (<Loading pageLoading />)
  }
}

export default TaxStatements



// WEBPACK FOOTER //
// ./src/views/Documents/DocumentsView.js